import React, {
  useState,
  useRef,
  useEffect,
  Fragment,
  useContext,
} from "react";
import { HamburgerMenuSVG } from "@icons";
import { Link } from "react-router-dom";
import {
  RECENTPURCHASE,
  BESTOFFER,
  MOSTPOPULAR,
  PRODUCTS,
} from "@constants/Routes";
import {
  currentString,
  currentPage,
  setCompleted,
} from "@slices/Products/productSearch";
import { useTranslation } from "react-i18next";
import Menu from "../../Catalog/Menu/Menu";
import { useGetLoggedInUserInfo } from "@hooks";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import { productsOnSaleSelector } from "@slices/Promotions/productsOnSale";
import { CATALOG } from "@constants/Routes";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const MenuBar: React.FC<{ menu: boolean; onMenuChange: any }> = (props) => {
  const webSettingsData: any = useContext(WebSettingsContext);
  const { t, i18n } = useTranslation();
  const sessionId = useGetLoggedInUserInfo()?.sessionId;
  const history = useHistory();
  const dispatch = useDispatch();

  const state = useSelector(productsOnSaleSelector);

  const saleClicked = () => {
    history.push(`${CATALOG}/${state?.productsOnSale?.code}/`);
  };

  const onSubmit = () => {
    dispatch(currentPage(1));
    dispatch({
      type: currentString,
      payload: "",
    });
    dispatch(setCompleted(false));
    // //setLoader(true);
    // setSearchText("");
    // dispatch({
    //   type: getCompareDetails,
    //   payload: [],
    // });
  };

  return (
    <Fragment>
      {props.menu && <Menu show={props.menu} onClose={props.onMenuChange} />}
      <nav className="menubar-container mobile-hide">
        <div className="nav-center">
          <div className="links-container show-container">
            <ul className="menu-items">
              <li>
                <a onClick={props.onMenuChange}>
                  <HamburgerMenuSVG className="secondary-icon-3" />{" "}
                  {t("CON_SHOP_BY_CATEGORY")}
                </a>
              </li>
              {webSettingsData?.showPromotionalItems ? (
                <li>
                  <Link to={BESTOFFER}>
                    <a href="">{t("CON_BEST_OFFERS")}</a>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {state?.productsOnSale?.code !== undefined && (
                <li onClick={() => saleClicked()}>
                  <a style={{ cursor: "pointer" }}>{t("CON_SALE")}</a>
                </li>
              )}
              {webSettingsData?.showMostPopularItems ? (
                <li>
                  <Link to={MOSTPOPULAR}>
                    <a href="">{t("CON_MOST_POPULAR")}</a>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {sessionId ? (
                <li>
                  <Link to={sessionId ? RECENTPURCHASE : "#"}>
                    <a>{t("CON_RECENT_PURCHASES")}</a>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {/* <li style={{ cursor: "pointer" }}>
                <Link to={PRODUCTS}>
                  <a href="">{t("CON_ALLPRODUCTS")}</a>
                </Link>
              </li> */}
            </ul>
            <div onClick={() => onSubmit()} className="product-right-link">
              <Link to={PRODUCTS}>
                <a href="">{t("CON_ALLPRODUCTS")}</a>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

export default MenuBar;
